import React from 'react'
import RichCta from 'components/rich-cta'
import config from 'config'
import WidgetPage from 'components/hocs/widget-page'

const RichCtaApp = props => (
  <RichCta
    url={`${config.credibleRoot}/refinance-student-loans`}
    title="Easily refinance your student loans."
    body="Compare rates from up to 10 lenders in minutes."
    ctaText="Get Started"
    {...props}
  />
)

export default WidgetPage(RichCtaApp)
